import React, { Component } from "react";
import Toggle from "./ToogleComponent";
import { middlewareService } from "../../shared/service";
import middlewareConstants from "../../shared/middleware-constant";
import { toast } from "react-toastify";

class ToogleBtn extends Component {
  constructor(props) {
    super(props);
    this.state = {
      size: "default",
      disabled: false,
    };
  }

  componentDidMount() {
    this.getConsent();
  }

  getConsent = () => {
    let _url = "/users/getConsent";
    let payload = {
      type: "whatsapp",
    };
    let requestOptions = middlewareConstants.requestWithCredentialsJsonBSE;
    requestOptions.body = JSON.stringify(payload);
    middlewareService
      .servicePost(process.env.REACT_APP_REPORTS_API_URL + _url, requestOptions)
      .then((response) => {
        this.setState({ checked: response?.consent });
      });
  };

  setConsent = () => {
    let _url = "/users/setConsent";
    let payload = {
      type: "whatsapp",
      consent: this.state.checked,
    };
    let requestOptions = middlewareConstants.requestWithCredentialsJsonBSE;
    requestOptions.body = new URLSearchParams(payload);
    middlewareService
      .servicePost(process.env.REACT_APP_REPORTS_API_URL + _url, requestOptions)
      .then((response) => {
        if (response && response.successs) {
          toast.info(response.message || "Consent recorded");
        }
      });
  };

  handleChange = (e) => {
    this.setState({ checked: !this.state.checked }, () => {
      this.setConsent();
    });
  };

  setSize(e) {
    this.setState((prevState) => ({
      size: prevState.size === "default" ? "large" : "default",
    }));
  }

  setDisable(e) {
    this.setState((prevState) => ({
      disabled: !prevState.disabled,
    }));
  }

  render() {
    return (
      <form>
        <Toggle
          checked={this.state.checked}
          disabled={this.state.disabled}
          onChange={this.handleChange}
          offstyle="btn-dark"
          onstyle="btn-success"
          border
        />
      </form>
    );
  }
}

export default ToogleBtn;
